// config.js
const BaseUrl = 'https://offerapi.adomobi.com/';
export default BaseUrl; 